import ClassNames from "classnames";
import { FunctionComponent } from "react";
import { connect, ConnectedProps, MapStateToProps } from "react-redux";
import { getActiveSite } from "../../selectors/sites.js";
import {
  BaseModuleProps,
  ColorScheme,
  StoreState,
  WeatherModuleSettings,
  WeatherWidgetSettings,
} from "../../types/index.js";
import ModuleHeadings from "../ModuleHeadings.js";
import ModuleWithHeadings from "../ModuleWithHeadings.js";
import WeatherWidget from "../WeatherWidget.js";

interface Props extends BaseModuleProps<WeatherModuleSettings> {
  scheme: ColorScheme;
}

interface StateProps {
  settings: WeatherWidgetSettings;
}

type ReduxProps = ConnectedProps<typeof connector>;

const WeatherModule: FunctionComponent<Props & ReduxProps> = ({
  translatedModule: {
    id,
    settings: { textAlign },
    translation: {
      settings: { title, subtitle },
    },
  },
  settings,
  isFirstOnPage,
}) => (
  <ModuleWithHeadings
    title={title}
    subtitle={subtitle}
    id={id}
    className={ClassNames(
      "WeatherModule",
      `WeatherModule--align-${textAlign.description}`,
    )}
    colors={{ background: settings.colorScheme.main.background }}
  >
    <ModuleHeadings
      scheme={settings.colorScheme}
      isFirstOnPage={isFirstOnPage}
      textAlign={textAlign}
      title={title}
      subtitle={subtitle}
    />

    <WeatherWidget settings={settings} />
  </ModuleWithHeadings>
);

const mapStateToProps: MapStateToProps<StateProps, Props, StoreState> = (
  { sites },
  { translatedModule, scheme },
): StateProps => {
  const site = getActiveSite(sites);

  const {
    translation: { languageId },
    settings: { districtId, iconStyle },
  } = translatedModule;

  return {
    settings: {
      propertyId: site.accommodation.id,
      lang: languageId,
      colorScheme: scheme,
      districtId,
      iconStyle,
    },
  };
};

const connector = connect(mapStateToProps);

export default connector(WeatherModule);
